import { TranslationCultureResponse } from '@/main/models/response/translationCultureResponse';
import { TranslateTypes, TranslateActionTypes } from './translateTypes';

export function getTranslates(culture: string): TranslateActionTypes {
  return {
    type: TranslateTypes.GET_TRANSLATES,
    payload: { culture }
  };
}

export function saveTranslates(
  data: TranslationCultureResponse | null,
  cultureUserLogged: string | null,
  isError: boolean,
  errorMessages: string[] | null
): TranslateActionTypes {
  return {
    type: TranslateTypes.SAVE_TRANSLATES,
    payload: { data, isError, errorMessages, cultureUserLogged }
  };
}

export function resetReducerTranslates(): TranslateActionTypes {
  return {
    type: TranslateTypes.RESET_REDUCER_TRANSLATES
  };
}
